import store from '../Store/index'

function moneyFormat(converted_price, locale = 'es-CO', currencyDisplay = 'symbol'){
    let digits = 0;
    switch (store.getters.getMyState.currency) {
        case 'BTC':
            digits = 10;
            break;
    }

    if(converted_price>1){
        digits = 0;
    }

    let formated_price = Number(converted_price).toLocaleString(locale, {
        style: 'currency',
        currency: store.getters.getMyState.currency,
        currencyDisplay: currencyDisplay,
        minimumFractionDigits: digits
    });

    return formated_price;
}

export default function usePriceFormat(price) {

    let converted_price = usePriceCovert(price, store.getters.getMyState.currency);

    let formated_price = moneyFormat(converted_price);

    return formated_price
}

export function useMarketValueFormat(price) {
    let converted_price = usePriceCovert(price, store.getters.getMyState.currency);

    // Keep market values complete while following the selected currency and
    // the same live exchange rates used by the rest of the application.
    return moneyFormat(converted_price, 'en-US', 'narrowSymbol');
}

export function usePriceCovert(price, currency) {

    let currenciesValues = store.getters.getMyState.currenciesValues;

    let converted_price = price;
    let cop_price = price * store.getters.getMyState.usdRate;

    switch (currency) {
        case 'COP':
            converted_price = cop_price;
            break;
        case 'BTC':
            converted_price = price / currenciesValues[0].current_price;
            break;
    }

    return converted_price
}

export function usePriceFormatShort(price) {

    let converted_price = usePriceCovert(price, store.getters.getMyState.currency);

    if (converted_price < 1e3) return moneyFormat(converted_price);
    if (converted_price >= 1e3 && converted_price < 1e6) return moneyFormat(+(converted_price / 1e3).toFixed(1)) + "K";
    if (converted_price >= 1e6 && converted_price < 1e9) return moneyFormat(+(converted_price / 1e6).toFixed(1)) + "M";
    if (converted_price >= 1e9 && converted_price < 1e12) return moneyFormat(+(converted_price / 1e9).toFixed(1)) + "B";
    if (converted_price >= 1e12) return moneyFormat(+(converted_price / 1e12).toFixed(1)) + "MM";

    return converted_price
}
